























import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';
import { client } from '../../store';
import { IAgreementType, IPageParams } from '../../models';
import paginationMixin from '@/mixins/pagintation';
@Component({
  components: {
    UIActions: () => import('@/components/UI/Actions.vue'),
  },
  data: () => ({
    namespace: 'agreementType',
  }),
  mixins: [paginationMixin],
})
export default class AgreementTypeList extends Vue {
  @Action('getEntities', { namespace: 'agreementType' })
  getEntities: () => void;
  @Getter('entitiesSlice', { namespace: 'agreementType' })
  entitiesSlice: IAgreementType[];
  @State('pageParams', { namespace: 'agreementType' })
  pageParams: IPageParams;
  headers = [{ text: 'Название', value: 'name' }];
  selected = [];
  interval = null;
  created() {
    this.getEntities();
  }
}
